import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from './AppUserProfile';
import { SrubUpService } from './ScrubUp.service';

@Injectable()
export class RouteTrackerService {

    constructor(
    private router: Router,
    private cookieService: CookieService,
    private scrubUpService: SrubUpService
  ) {
    console.log('Initializing RouteTrackerService...');
    // Subscribe to router events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // This code will run on every page navigation
      console.log('Navigation to:', event.url);

      // Call the test API on every page navigation
      this.getPackageTypesFeaturesByUserId(event.url);
    });
  }

    // Call the test API on every page navigation
  private getPackageTypesFeaturesByUserId(currentRoute: string) {
    // Get token from cookie if available
    if (this.cookieService.check('Token')) {
      try {
        const tokenData = JSON.parse(this.cookieService.get('Token'));

        // Call the test API function from SrubUpService
        this.scrubUpService
          .getPackageTypesFeaturesByUserId(tokenData, currentRoute)
          .subscribe(
            (data) => {
              const responseData = data.Data ? data.Data : [];
console.log("responseData================", responseData);
              const result = responseData.find(
                (item) => item.UserPackageTypeID > 0
              );

              const { PackageTypesFeaturesList, ...packageType } = result;

              this.cookieService.set(
                "PackageTypesFeatures",
                JSON.stringify(packageType)
              );

              const procedure = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "procedure"
              );

              if (procedure) {
                localStorage.setItem("Procedure", JSON.stringify(procedure));
              }

              const surgeon = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "surgeon"
              );

              if (surgeon) {
                localStorage.setItem("Surgeon", JSON.stringify(surgeon));
              }

              const share = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "share"
              );

              if (share) {
                localStorage.setItem("Share", JSON.stringify(share));
              }

              const step = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "step"
              );

              if (step) {
                localStorage.setItem("Step", JSON.stringify(step));
              }

              const professionalLearning = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "professionallearning"
              );

              if (professionalLearning) {
                localStorage.setItem("ProfessionalLearning", JSON.stringify(professionalLearning));
              }

              const image = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "Image"
              );

              if (image) {
                localStorage.setItem("Image", JSON.stringify(image));
              }

              const patientpositioning = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "patientpositioning"
              );

              if (patientpositioning) {
                localStorage.setItem("PatientPositioning", JSON.stringify(patientpositioning));
              }

              const journal = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "journal"
              );

              if (journal) {
                localStorage.setItem("Journal", JSON.stringify(journal));
              }

              const profesionallearning = PackageTypesFeaturesList.find(
                (item) => item.FeatureName === "profesionallearning"
              );

              if (profesionallearning) {
                localStorage.setItem("ProfesionalLearning", JSON.stringify(profesionallearning));
              }
            },
            (error) => {
              console.error("API test failed for route:", currentRoute, error);
            }
        );
      } catch (err) {
        console.error('Error parsing token data:', err);
      }
    } else {
      console.log('No token available for API test on route:', currentRoute);
    }
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Services/route-tracker.service.ts